import { useCallback, useState } from 'react';

import { localStorage } from '@gitbook/util-local-storage';

/**
 * A simple hook to manage a dismissed state using localStorage.
 */
export function useDismissedState(keyInput: string): [boolean, () => void] {
    const key = getKey(keyInput);
    const [isDismissed, setIsDismissed] = useState(() => {
        try {
            const stored = localStorage.get(key);
            return stored !== null && stored === 'true';
        } catch {
            return false;
        }
    });

    const dismiss = useCallback(() => {
        try {
            localStorage.set(key, 'true');
            setIsDismissed(true);
        } catch {
            // Silently fail if localStorage is not available
        }
    }, [key]);

    return [isDismissed, dismiss];
}

function getKey(key: string): string {
    return `@gitbook/dismissed:${key}`;
}
